import { CtaButton } from "@/components/CtaButton";
import { site } from "@/config/site.config";

export const TopBar = () => (
  <header
    data-testid="top-bar"
    className="sticky top-0 z-40 border-b border-white/10 bg-ink/85 backdrop-blur-md"
  >
    <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3.5">
      <a href="/" data-testid="brand-link" className="font-mono text-[11px] font-bold tracking-[0.25em] text-cream">
        WILD WOMAN <span className="text-lime">MILLIONS</span>™
      </a>
      <div className="flex items-center gap-4">
        <span className="hidden font-mono text-xs text-cream/50 sm:block">CLARITY IS CURRENCY™</span>
        <CtaButton id="topbar" className="!min-h-[40px] !px-4 !py-2 !text-[11px] whitespace-nowrap sm:!px-5 sm:!text-xs">
          ENTER — {site.price}
        </CtaButton>
      </div>
    </div>
  </header>
);
